import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SecurityRouterStoreSelectors, UserGroupAclStoreActions, UserGroupAclStoreSelectors } from '@era/stores';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NamedUserGroupAcl, isNotUndefined } from '@rocksoft/shared';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { GroupPermissionsEntityListComponent } from './group-permissions-entity-list.component';

@Component({
  selector: 'era-group-permissions-entity-list',
  templateUrl: './group-permissions-entity-list.container.html',
  imports: [GroupPermissionsEntityListComponent, AsyncPipe],
})
export class GroupPermissionsEntityListContainerComponent {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

  public readonly acl$: Observable<NamedUserGroupAcl | undefined>;
  public readonly error$: Observable<string>;

  constructor() {
    this.acl$ = this.store
      .select(SecurityRouterStoreSelectors.selectCurrentGroupId)
      .pipe(
        switchMap((groupId) =>
          groupId
            ? this.store
                .select(UserGroupAclStoreSelectors.selectUserGroupAclByResourceWithName(groupId))
                .pipe(filter(isNotUndefined))
            : of(undefined)
        )
      );
    this.error$ = this.actions$
      .pipe(ofType(UserGroupAclStoreActions.AccessControlListApiActions.userGroupAclLoadedError))
      .pipe(map(() => 'An unknown error has occurred.'));
  }
}
